import Masthead from '@/vues/info/masthead.vue';
import Terms from '@/vues/info/terms.vue';
import Privacy from '@/vues/info/privacy.vue';

export default [
  {
    path: '/masthead',
    name: 'Info Masthead',
    component: Masthead
  },
  {
    path: '/terms',
    name: 'Info Terms',
    component: Terms
  },
  {
    path: '/privacy',
    name: 'Info Privacy',
    component: Privacy
  }
];
